/* tslint:disable */
/* eslint-disable */
/**
 * Swagger Corporate Site API
 * This is a rest-api server.
 *
 * OpenAPI spec version: 1.0
 * Contact: support@swagger.io
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ContractsWrappedError } from '../models';
import { NewsNews } from '../models';
import { NewsNewsList } from '../models';
import { NewsPatchRequest } from '../models';
/**
 * NewsApi - axios parameter creator
 * @export
 */
export const NewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Удаление новости
         * @summary Удаление новости
         * @param {string} id identificator of news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNews: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNews.');
            }
            const localVarPath = `/api/corpsite/v1/news/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение новости по id
         * @summary Получение новости по id
         * @param {string} id newsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntity: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNewsEntity.');
            }
            const localVarPath = `/api/corpsite/v1/news/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение списка новостей в соответствии с фильтром
         * @summary Получение списка новостей в соответствии с фильтром
         * @param {string} [id] фильтрация по id
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {Array&lt;number&gt;} [status] Статусы
         * @param {string} [author] Уникальный идентификатор пользователя - автора новости (me - для получения новостей, автором которых является текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsList: async (id?: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, status?: Array<number>, author?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corpsite/v1/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (rubric) {
                localVarQueryParameter['rubric'] = rubric.join(COLLECTION_FORMATS.csv);
            }

            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение списка опубликованных новостей в соответствии с фильтром
         * @summary Получение списка опубликованных новостей (неавторизованая зона)
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsListPublished: async (searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/corpsite/v1/news/published`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (rubric) {
                localVarQueryParameter['rubric'] = rubric.join(COLLECTION_FORMATS.csv);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
         * @summary Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
         * @param {string} id id новости-черновика, которую надо присоединить к результату
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsListWithDraft: async (id: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNewsListWithDraft.');
            }
            const localVarPath = `/api/corpsite/v1/news/draft/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sortField'] = sortField;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (rubric) {
                localVarQueryParameter['rubric'] = rubric.join(COLLECTION_FORMATS.csv);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение опубликованной новости по id
         * @summary Получение опубликованной новости по id (неавторизованая зона)
         * @param {string} id Id опубликованной новости
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsPublishedEntity: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNewsPublishedEntity.');
            }
            const localVarPath = `/api/corpsite/v1/news/published/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Изменение некоторых полей новости по ее идентификатору
         * @summary Частичное изменение новости
         * @param {NewsPatchRequest} body изменяемые данные
         * @param {string} id id новости-черновика, которую надо присоединить к результату
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchNews: async (body: NewsPatchRequest, id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling patchNews.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling patchNews.');
            }
            const localVarPath = `/api/corpsite/v1/news/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Сохранение новости
         * @summary Сохранение новости
         * @param {NewsNews} body Сохранение новости в хранилище
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNews: async (body: NewsNews, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling saveNews.');
            }
            const localVarPath = `/api/corpsite/v1/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsApi - functional programming interface
 * @export
 */
export const NewsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Удаление новости
         * @summary Удаление новости
         * @param {string} id identificator of news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNews(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).deleteNews(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение новости по id
         * @summary Получение новости по id
         * @param {string} id newsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsEntity(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsNews>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).getNewsEntity(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение списка новостей в соответствии с фильтром
         * @summary Получение списка новостей в соответствии с фильтром
         * @param {string} [id] фильтрация по id
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {Array&lt;number&gt;} [status] Статусы
         * @param {string} [author] Уникальный идентификатор пользователя - автора новости (me - для получения новостей, автором которых является текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsList(id?: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, status?: Array<number>, author?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsNewsList>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).getNewsList(id, searchString, sortField, sortDirection, size, offset, rubric, status, author, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение списка опубликованных новостей в соответствии с фильтром
         * @summary Получение списка опубликованных новостей (неавторизованая зона)
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsListPublished(searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsNewsList>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).getNewsListPublished(searchString, sortField, sortDirection, size, offset, rubric, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
         * @summary Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
         * @param {string} id id новости-черновика, которую надо присоединить к результату
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsListWithDraft(id: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsNewsList>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).getNewsListWithDraft(id, searchString, sortField, sortDirection, size, offset, rubric, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Получение опубликованной новости по id
         * @summary Получение опубликованной новости по id (неавторизованая зона)
         * @param {string} id Id опубликованной новости
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsPublishedEntity(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsNews>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).getNewsPublishedEntity(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Изменение некоторых полей новости по ее идентификатору
         * @summary Частичное изменение новости
         * @param {NewsPatchRequest} body изменяемые данные
         * @param {string} id id новости-черновика, которую надо присоединить к результату
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchNews(body: NewsPatchRequest, id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsPatchRequest>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).patchNews(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Сохранение новости
         * @summary Сохранение новости
         * @param {NewsNews} body Сохранение новости в хранилище
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveNews(body: NewsNews, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsNews>> {
            const localVarAxiosArgs = await NewsApiAxiosParamCreator(configuration).saveNews(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * NewsApi - factory interface
 * @export
 */
export const NewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Удаление новости
         * @summary Удаление новости
         * @param {string} id identificator of news
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNews(id: string, options?: any): AxiosPromise<string> {
            return NewsApiFp(configuration).deleteNews(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение новости по id
         * @summary Получение новости по id
         * @param {string} id newsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsEntity(id: string, options?: any): AxiosPromise<NewsNews> {
            return NewsApiFp(configuration).getNewsEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение списка новостей в соответствии с фильтром
         * @summary Получение списка новостей в соответствии с фильтром
         * @param {string} [id] фильтрация по id
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {Array&lt;number&gt;} [status] Статусы
         * @param {string} [author] Уникальный идентификатор пользователя - автора новости (me - для получения новостей, автором которых является текущий пользователь)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsList(id?: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, status?: Array<number>, author?: string, options?: any): AxiosPromise<NewsNewsList> {
            return NewsApiFp(configuration).getNewsList(id, searchString, sortField, sortDirection, size, offset, rubric, status, author, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение списка опубликованных новостей в соответствии с фильтром
         * @summary Получение списка опубликованных новостей (неавторизованая зона)
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsListPublished(searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options?: any): AxiosPromise<NewsNewsList> {
            return NewsApiFp(configuration).getNewsListPublished(searchString, sortField, sortDirection, size, offset, rubric, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
         * @summary Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
         * @param {string} id id новости-черновика, которую надо присоединить к результату
         * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
         * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
         * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
         * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
         * @param {number} [offset] Смещение от начала, по умолчанию 0
         * @param {Array&lt;string&gt;} [rubric] рубрики
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsListWithDraft(id: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options?: any): AxiosPromise<NewsNewsList> {
            return NewsApiFp(configuration).getNewsListWithDraft(id, searchString, sortField, sortDirection, size, offset, rubric, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение опубликованной новости по id
         * @summary Получение опубликованной новости по id (неавторизованая зона)
         * @param {string} id Id опубликованной новости
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsPublishedEntity(id: string, options?: any): AxiosPromise<NewsNews> {
            return NewsApiFp(configuration).getNewsPublishedEntity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Изменение некоторых полей новости по ее идентификатору
         * @summary Частичное изменение новости
         * @param {NewsPatchRequest} body изменяемые данные
         * @param {string} id id новости-черновика, которую надо присоединить к результату
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchNews(body: NewsPatchRequest, id: string, options?: any): AxiosPromise<NewsPatchRequest> {
            return NewsApiFp(configuration).patchNews(body, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Сохранение новости
         * @summary Сохранение новости
         * @param {NewsNews} body Сохранение новости в хранилище
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveNews(body: NewsNews, options?: any): AxiosPromise<NewsNews> {
            return NewsApiFp(configuration).saveNews(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsApi - object-oriented interface
 * @export
 * @class NewsApi
 * @extends {BaseAPI}
 */
export class NewsApi extends BaseAPI {
    /**
     * Удаление новости
     * @summary Удаление новости
     * @param {string} id identificator of news
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public deleteNews(id: string, options?: any) {
        return NewsApiFp(this.configuration).deleteNews(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение новости по id
     * @summary Получение новости по id
     * @param {string} id newsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNewsEntity(id: string, options?: any) {
        return NewsApiFp(this.configuration).getNewsEntity(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение списка новостей в соответствии с фильтром
     * @summary Получение списка новостей в соответствии с фильтром
     * @param {string} [id] фильтрация по id
     * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
     * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
     * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
     * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
     * @param {number} [offset] Смещение от начала, по умолчанию 0
     * @param {Array&lt;string&gt;} [rubric] рубрики
     * @param {Array&lt;number&gt;} [status] Статусы
     * @param {string} [author] Уникальный идентификатор пользователя - автора новости (me - для получения новостей, автором которых является текущий пользователь)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNewsList(id?: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, status?: Array<number>, author?: string, options?: any) {
        return NewsApiFp(this.configuration).getNewsList(id, searchString, sortField, sortDirection, size, offset, rubric, status, author, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение списка опубликованных новостей в соответствии с фильтром
     * @summary Получение списка опубликованных новостей (неавторизованая зона)
     * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
     * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
     * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
     * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
     * @param {number} [offset] Смещение от начала, по умолчанию 0
     * @param {Array&lt;string&gt;} [rubric] рубрики
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNewsListPublished(searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options?: any) {
        return NewsApiFp(this.configuration).getNewsListPublished(searchString, sortField, sortDirection, size, offset, rubric, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
     * @summary Получение списка новостей в соответствии с фильтром + дополнительно черновик по id
     * @param {string} id id новости-черновика, которую надо присоединить к результату
     * @param {string} [searchString] фильтрация по содержимому (заголовок,...)
     * @param {string} [sortField] Сортировка по полю: datefrom, aboutproject.projectcost, 
     * @param {number} [sortDirection] Направление сортировки -1 (desc), 1 (asc)
     * @param {number} [size] Количество выдаваемых строк, по умолчанию 10
     * @param {number} [offset] Смещение от начала, по умолчанию 0
     * @param {Array&lt;string&gt;} [rubric] рубрики
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNewsListWithDraft(id: string, searchString?: string, sortField?: string, sortDirection?: number, size?: number, offset?: number, rubric?: Array<string>, options?: any) {
        return NewsApiFp(this.configuration).getNewsListWithDraft(id, searchString, sortField, sortDirection, size, offset, rubric, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Получение опубликованной новости по id
     * @summary Получение опубликованной новости по id (неавторизованая зона)
     * @param {string} id Id опубликованной новости
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getNewsPublishedEntity(id: string, options?: any) {
        return NewsApiFp(this.configuration).getNewsPublishedEntity(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Изменение некоторых полей новости по ее идентификатору
     * @summary Частичное изменение новости
     * @param {NewsPatchRequest} body изменяемые данные
     * @param {string} id id новости-черновика, которую надо присоединить к результату
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public patchNews(body: NewsPatchRequest, id: string, options?: any) {
        return NewsApiFp(this.configuration).patchNews(body, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Сохранение новости
     * @summary Сохранение новости
     * @param {NewsNews} body Сохранение новости в хранилище
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public saveNews(body: NewsNews, options?: any) {
        return NewsApiFp(this.configuration).saveNews(body, options).then((request) => request(this.axios, this.basePath));
    }
}
